import { useEffect, useRef } from 'react';

interface CameraPreviewProps {
  stream: MediaStream | null;
}

/**
 * Shows a live camera preview for the selected device.
 */
export function CameraPreview({ stream }: CameraPreviewProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.srcObject = stream;
  }, [stream]);

  if (!stream) {
    return (
      <div className="aspect-square rounded-2xl border border-white/10 bg-surface-200/60 flex items-center justify-center text-ink-300">
        Camera preview unavailable
      </div>
    );
  }

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      className="aspect-square rounded-2xl border border-white/10 object-cover"
    />
  );
}
